import AllCampaigns from "./AllCampaigns";

export default AllCampaigns;